// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @26.11.2021 13:30:59
import { CPersonHistory_abstract } from './../../abstract/SagaSchema/History/CPersonHistory_abstract';

export class CPersonHistory extends CPersonHistory_abstract {}
